import { Component, OnInit, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MembershipPaymentService } from '../services/membership-payment.service';

declare var App; 

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() userDetails;
 
  isShown:boolean = false;
  hrefUrl = App.froent_end_url;
  baseUrl = App.base_url;
  linkValue;
  
  constructor(private m_pService: MembershipPaymentService,
              private router: Router) { }
 
  public logo = App.public_url + 'telemedicine/assets/images/coloredlogo1.svg';
  public userIcon = App.public_url + 'telemedicine/assets/images/user_avatar.svg';

  ngOnInit() {
  }

  goToPage(event){
    if(!App.user_details) {
      window.location.href = App.froent_end_url + event
      // this.router.navigate([App.froent_end_url + event]);
    }
    var newForm = document.createElement('form');
    newForm.setAttribute('id', 'newForm');
    newForm.setAttribute('method', 'post');
    if(event == 'logout') {
      newForm.setAttribute('action', App.froent_end_url + 'telemedicine');      
    }else{
      newForm.setAttribute('action', App.froent_end_url + event);
    }

    var hidden_user = document.createElement("input");
    hidden_user.type = "hidden";
    hidden_user.id = "userId";
    hidden_user.name = "userId";
    hidden_user.value = App.user_details.id;

    var hidden_flag = document.createElement("input");
    hidden_flag.type = "hidden";
    hidden_flag.id = "nav_flag";
    hidden_flag.name = "nav_flag";
    hidden_flag.value = "true";

    if(event == 'logout') {
      var hidden_logout = document.createElement("input");
      hidden_logout.type = "hidden";
      hidden_logout.id = "logout";
      hidden_logout.name = "logout";
      hidden_logout.value = "true";
    newForm.appendChild(hidden_logout);    
    }

    newForm.appendChild(hidden_user);
    newForm.appendChild(hidden_flag);

    document.body.appendChild(newForm);

    newForm.submit();
  }

  logout() {
    this.m_pService.logoutApi({type: 'telemedicine'}).subscribe(response => {
      this.goToPage('logout')
      // window.location.href= this.hrefUrl;
		});
  }

  subscriptions(){
    this.router.navigate(['/subscriptions']);
  }



}

